// A small, safe Markdown subset for private posts. Raw HTML remains literal text.
export type Inline = { text: string; style?: 'strong' | 'emphasis' | 'code'; href?: string };
export type MarkdownBlock = { kind: 'paragraph' | 'heading' | 'quote' | 'list' | 'code'; text: string };

export function safeMarkdownLink(url: string): boolean {
  return /^https?:\/\/[^\s]+$/i.test(url);
}

export function markdownInline(text: string): Inline[] {
  const pattern = /\[([^\]\n]+)\]\(([^\s)]+)\)|\*\*([^*\n]+)\*\*|__([^_\n]+)__|`([^`\n]+)`|\*([^*\n]+)\*/g;
  const out: Inline[] = [];
  let from = 0;
  for (const m of text.matchAll(pattern)) {
    if (m.index > from) out.push({ text: text.slice(from, m.index) });
    if (m[1]) out.push(safeMarkdownLink(m[2]) ? { text: m[1], href: m[2] } : { text: m[0] });
    else out.push({ text: m[3] ?? m[4] ?? m[5] ?? m[6], style: m[3] || m[4] ? 'strong' : m[5] ? 'code' : 'emphasis' });
    from = m.index + m[0].length;
  }
  if (from < text.length) out.push({ text: text.slice(from) });
  return out;
}

export function markdownBlocks(markdown: string): MarkdownBlock[] {
  const blocks: MarkdownBlock[] = [];
  let code: string[] | null = null;
  for (const line of markdown.replace(/\r\n?/g, '\n').split('\n')) {
    if (/^\s*```/.test(line)) {
      if (code) { blocks.push({ kind: 'code', text: code.join('\n') }); code = null; }
      else code = [];
    } else if (code) code.push(line);
    else if (/^#{1,6}\s+/.test(line)) blocks.push({ kind: 'heading', text: line.replace(/^#{1,6}\s+/, '') });
    else if (/^>\s?/.test(line)) blocks.push({ kind: 'quote', text: line.replace(/^>\s?/, '') });
    else if (/^\s*(?:[-*+] |\d+\. )/.test(line)) blocks.push({ kind: 'list', text: line.replace(/^\s*(?:[-*+] |\d+\. )/, '• ') });
    else blocks.push({ kind: 'paragraph', text: line });
  }
  if (code) blocks.push({ kind: 'code', text: code.join('\n') });
  return blocks;
}
